import React from 'react'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import CrossedPrice from 'components/ui/CrossedPrice/CrossedPrice'
import UpchargePrice from 'components/UpchargePrice/UpchargePrice'

import ArrivalDate from '../ArrivalDate/ArrivalDate'
import ProductImage from '../ProductImage/ProductImage'
import RemoveIcon from './RemoveIcon/RemoveIcon'

import s from './PickProduct.scss'
import messages from './messages'


const PickProduct = ({
  id, name, brand, image, upchargePrice, discount,
  month, year, price, priceWithDiscount, onRemove,
}) => (
  <Box
    className={s.product}
    pt="8"
  >
    <div className={s.imageWrapper}>
      {
        Boolean(upchargePrice && !price) && (
          <Box
            className={s.upchargePrice}
            pt="8"
          >
            <UpchargePrice price={upchargePrice} />
          </Box>
        )
      }
      <ProductImage image={image} />
    </div>
    <div className={s.productInfoContainer}>
      <div className={s.productInfoWrapper}>
        {
          Boolean(brand && name) ? (
            <div className={s.productInfo}>
              <Text className={s.brand} size="18-24" semibold>{brand}</Text>
              <Text className={s.subTitle}>{name}</Text>
            </div>
          ) : (
            <div className={s.productInfo}>
              <Text message={messages.pom.title} size="16-24" semibold />
              <Text className={s.subTitle} message={messages.pom.subTitle} />
            </div>
          )
        }
        <RemoveIcon
          className={s.removeIcon}
          id={id}
          onRemove={onRemove}
        />
      </div>
      {
        Boolean(month) && (
          <ArrivalDate month={month} year={year} />
        )
      }
    </div>
    {
      Boolean(price) && (
        <Box className={s.price} alignRight>
          {
            Boolean(priceWithDiscount) ? (
              <div>
                <Text
                  message={messages.firstMonth}
                  values={{ priceWithDiscount }}
                  size="16-24"
                  semibold
                />
                <Text size="16-24">
                  <CrossedPrice />
                </Text>
              </div>
            ) : (
              <Text size="16-24" semibold>{price}</Text>
            )
          }
          {
            Boolean(discount) && (
              <Text
                message={messages.saved}
                values={{ discount }}
                size="16-24"
                color="brand"
                semibold
              />
            )
          }
          {
            Boolean(upchargePrice) && (
              <UpchargePrice price={upchargePrice} />
            )
          }
        </Box>
      )
    }
  </Box>
)


export default PickProduct
